import {IStationApi} from '../../api/station-api.service';
import {IStation, IAggregationsData} from '../../api/api.types';
import {IStationDetails} from '../details/edit.controller';

export default class StationCreatorAggregationsEditController {
	static $inject = ['stationApi', '$scope'];

	stationDetails:IStationDetails;

	private searchText: string;
	private selectedStations: IAggregationsData[] = [];

	onChange:(callbackArgs:{selectedStations:IAggregationsData[], isValid:boolean})=>void;

	constructor(
		private stationApi:IStationApi,
		private $scope: ng.IScope
	) {
		
	}

	$onChanges() {
		if (this.stationDetails && 
			this.stationDetails.aggregations &&
			this.stationDetails.aggregations.length
		) {
			this.selectedStations = angular.copy(this.stationDetails.aggregations);
		}
	}

	queryStations() {
		return this.stationApi.getDischargeStations()
			.then(stations => {
				if (stations && stations.length) {
				 stations = _.filter(stations, (station) => {
				    return !station.isVirtual;
				  })
				}
				return this.filterStationsByText(this.filterStationsBySelected(stations));
			});
	}

	onStationSelected(station: IStation) {
		if (station) {
			this.selectedStations.push({
				id: station.id,
				siteName: station.siteName,
				siteCode: station.siteCode,
				weighting:100
			});	
			this.form.$setSubmitted();

			this.$scope.$applyAsync(() => {
				this.notifyChange();
			});
		}

		this.searchText = null;
	}

	onWeightingFieldChange($event: MouseEvent) {
		this.notifyChange();
	}

	unselectStation(station: IAggregationsData) {
		this.selectedStations.splice(this.selectedStations.indexOf(station), 1);
		this.notifyChange();
	}

	filterStationsBySelected(fetchedStations: IStation[]) {
		return _.filter(fetchedStations, (station) => {
			let isItemSelected: boolean; 
			this.selectedStations.forEach((selectedStation) => {
				if (!isItemSelected) {
					isItemSelected = station.id === selectedStation.id;
				}
			}); 
			return !isItemSelected;
		});
	}

	filterStationsByText(stations: IStation[]) {
		if (this.searchText) {
			return _.filter(stations, (station) => {
				return station.siteName.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1 || 
						station.siteCode.indexOf(this.searchText) !== -1;
			});
		} else {
			return stations;
		}
	}

	private get form():ng.IFormController {
	  return this.$scope['aggregationsForm'] || null;
	}

	private notifyChange() {
	  if (this.onChange) {
	  	let isValid = this.form.$valid && Boolean(this.selectedStations.length);
	    this.onChange({selectedStations: this.selectedStations, isValid: isValid});
	  }
	}

}



/** WEBPACK FOOTER **
 ** ./app/station/aggregation/aggregationEdit.controller.ts
 **/